function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Planned_disruption");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "-0.00284900285 0.498575499 350 0.498575499 350 350.501424 -0.00284900285 350.501424"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Planned_disruption",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Unplanned_disruption",
  transform: "translate(0.000000, -0.500000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.999082,344.5 C268.341932,344.5 343.998575,268.833216 343.998575,175.506591 C343.998575,82.1667837 268.341932,6.5 174.999082,6.5 C81.6562332,6.5 5.9985755,82.1667837 5.9985755,175.506591 C5.9985755,268.833216 81.6562332,344.5 174.999082,344.5",
  id: "Fill-1",
  fill: "#FFFFFF",
  mask: "url(#mask-2)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.058906,104.835739 C175.187942,104.835739 164.733515,94.3554354 164.733515,81.5182321 C164.733515,68.6084629 175.187942,58.1907851 188.058906,58.1907851 C200.929869,58.1907851 211.384296,68.6084629 211.384296,81.5182321 C211.384296,94.3554354 200.929869,104.835739 188.058906,104.835739 L188.058906,104.835739 Z M193.04208,288.561625 C187.14935,290.774388 178.275462,292.051746 170.280316,292.051746 C142.480705,292.051746 126.652441,278.37258 133.174405,246.528085 L156.5326,134.281583 L197.787676,134.281583 L175.643217,240.76357 C173.108389,253.216075 175.134263,258.949774 188.22193,258.949774 C194.320429,258.949774 199.282728,257.983554 203.064095,256.706196 L193.04208,288.561625 Z M174.950364,5.5 C81.22633,5.5 4.9985755,81.77768 4.9985755,175.525845 C4.9985755,269.243195 81.22633,345.5 174.950364,345.5 C268.739011,345.5 344.998575,269.243195 344.998575,175.525845 C344.998575,81.77768 268.739011,5.5 174.950364,5.5 L174.950364,5.5 Z",
  id: "Fill-3",
  fill: "#E05730",
  mask: "url(#mask-2)"
})));

const SvgIconsPlannedDisruption = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "350px",
    height: "350px",
    viewBox: "0 0 350 350",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconsPlannedDisruption, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icons-planned-disruption.ac066bf9.svg";
export { ForwardRef as ReactComponent };